import {
  MISSING_VOICES_DOMAIN,
  TEACH_LEAGUE_DOMAIN,
  normalizeAppPath,
} from "./missingVoicesRouting";

export const SITE_NAME = "Teach League";
export const MISSING_VOICES_SITE_NAME = "Missing Voices";
export const TEACH_LEAGUE_ORIGIN = `https://${TEACH_LEAGUE_DOMAIN}`;
export const MISSING_VOICES_ORIGIN = `https://${MISSING_VOICES_DOMAIN}`;
export const DEFAULT_SEO_IMAGE_PATH = "/videos/waves-forward-poster.jpg";
export const DEFAULT_TWITTER_CARD = "summary_large_image";

export const buildAbsoluteUrl = (origin, pathname = "/") =>
  new URL(normalizeAppPath(pathname), origin).toString();

export const getTeachLeagueCanonicalUrl = (pathname = "/") =>
  buildAbsoluteUrl(TEACH_LEAGUE_ORIGIN, pathname);

export const getMissingVoicesCanonicalUrl = () =>
  buildAbsoluteUrl(MISSING_VOICES_ORIGIN, "/");

export const getSeoImageUrl = (
  origin = TEACH_LEAGUE_ORIGIN,
  imagePath = DEFAULT_SEO_IMAGE_PATH
) => new URL(imagePath, origin).toString();

export const buildWebSiteStructuredData = ({
  name = SITE_NAME,
  url = TEACH_LEAGUE_ORIGIN,
  description,
} = {}) => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name,
  url,
  description,
});

export const buildWebApplicationStructuredData = ({
  name,
  url,
  description,
  image,
  applicationCategory = "EducationalApplication",
} = {}) => ({
  "@context": "https://schema.org",
  "@type": "WebApplication",
  name,
  url,
  description,
  applicationCategory,
  operatingSystem: "Web",
  image,
  isAccessibleForFree: true,
});

const PRIVATE_ROUTE_CONFIGS = [
  {
    match: (pathname) =>
      pathname === "/mydata" ||
      pathname.startsWith("/mydata/") ||
      pathname === "/dashboard" ||
      pathname.startsWith("/dashboard/"),
    title: "Gradebook | Teach League",
    description:
      "Private gradebook, roster, and classroom insights workspace for Teach League accounts.",
  },
  {
    match: (pathname) => pathname === "/profile" || pathname === "/account",
    title: "Profile Settings | Teach League",
    description:
      "Private Teach League profile and account settings workspace.",
  },
  {
    match: (pathname) => pathname === "/wizard",
    title: "Lesson Planner Wizard | Teach League",
    description:
      "Private lesson-planning workflow for signed-in Teach League users.",
  },
  {
    match: (pathname) =>
      pathname === "/workspace" || pathname.startsWith("/plans/"),
    title: "Lesson Planner Workspace | Teach League",
    description:
      "Private lesson-planning workspace for drafting, revising, and reviewing plans in Teach League.",
  },
  {
    match: (pathname) => pathname === "/analytics",
    title: "Analytics | Teach League",
    description:
      "Private Teach League analytics and classroom performance workspace.",
  },
  {
    match: (pathname) => pathname === "/admin",
    title: "Admin Benchmarks | Teach League",
    description:
      "Private Teach League administration and benchmark reporting surface.",
  },
  {
    match: (pathname) => pathname === "/assignments",
    title: "Assignments | Teach League",
    description:
      "Private Teach League assignments and classroom workflow surface.",
  },
];

export const getPrivateRouteSeo = (pathname = "/") => {
  const normalizedPath = normalizeAppPath(pathname);
  const config = PRIVATE_ROUTE_CONFIGS.find((entry) =>
    entry.match(normalizedPath)
  );

  if (!config) return null;

  return {
    ...config,
    canonicalUrl: getTeachLeagueCanonicalUrl(normalizedPath),
    robots: "noindex, nofollow",
  };
};
